import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import {
  OrganizationPreferenceRequest,
  OrganizationPreferenceResponse,
} from '../../interface/organizationPreference.interface';
import { IErrorResponse } from '../../interface/main.interface';
import {
  getOrganizationPreferences,
  updateOrganizationPreferences,
} from '../../services/organization';

export const fetchOrganizationPreferences = createAsyncThunk<
  OrganizationPreferenceResponse,
  void,
  { rejectValue: IErrorResponse }
>('organizationPreference/fetch-all', async (_, { rejectWithValue }) => {
  try {
    const response = await getOrganizationPreferences();
    return response;
  } catch (err) {
    const error = err as AxiosError<IErrorResponse>;
    if (!error.response) {
      throw err;
    }
    return rejectWithValue(error.response.data);
  }
});

export const putOrganizationPreferences = createAsyncThunk<
  OrganizationPreferenceResponse,
  OrganizationPreferenceRequest,
  { rejectValue: IErrorResponse }
>('organizationPreference/update', async (payload, { rejectWithValue }) => {
  try {
    const response = await updateOrganizationPreferences(payload);
    return response;
  } catch (err) {
    const error = err as AxiosError<IErrorResponse>;
    if (!error.response) {
      throw err;
    }
    return rejectWithValue(error.response.data);
  }
});

export const organizationPreferenceActions = {
  fetchOrganizationPreferences,
  putOrganizationPreferences,
};
